import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import RecentExchangeStore from 'stores/RecentExchange';
import PropTypes from 'prop-types';

import NotFound from 'scenes/NotFound';
import Loading from 'scenes/Loading';
import Addresses from './scenes/Addresses';
import Amount from './scenes/Amount';
import SelectCoin from './scenes/SelectCoin';

import './styles.css';

const recentExchangeStore = new RecentExchangeStore();

class Pair extends Component {
  constructor(props) {
    super(props);

    this.onRecentExchangeStoreChange = this.onRecentExchangeStoreChange.bind(this);
    this.setPair = this.setPair.bind(this);

    this.state = {
      error: false,
      recentExchangeStore,
    };
  }

  componentWillMount() {
    this.setPair(this.props.match.params.pair);
  }

  componentDidMount() {
    recentExchangeStore.addListener(this.onRecentExchangeStoreChange);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.pair !== this.props.match.params.pair) {
      this.setPair(nextProps.match.params.pair);
    }
  }

  componentWillUnmount() {
    recentExchangeStore.removeListener(this.onRecentExchangeStoreChange);
  }

  onRecentExchangeStoreChange() {
    this.setState(recentExchangeStore);
  }

  setPair(pair) {
    const symbols = pair.toUpperCase().split('_');
    this.props.coinStore.getBySymbol(symbols[0], (fromError, fromCoin) => {
      if (fromError) return this.setState({ error: fromError });

      return this.props.coinStore.getBySymbol(symbols[1], (toError, toCoin) => {
        if (toError) return this.setState({ error: toError });

        return this.props.infoStore.setPair(fromCoin, toCoin, (pairError) => {
          this.setState({ error: pairError });
        });
      });
    });
  }

  render() {
    return (
      <div className="pair">
        {this.state.error ?
          <div className="error">{this.state.error} <Link className="error__link" to="/">Click here to go back</Link></div>
        : null}

        {this.props.infoStore.loaded ?
          <Switch>
            <Route
              exact
              path={`/${this.props.match.params.pair}/transaction/:id`}
              render={() => null}
            />
            <Route
              exact
              path={`/${this.props.match.params.pair}/addresses/:direction/:amount`}
              render={props => (
                <Addresses
                  {...props}
                  infoStore={this.props.infoStore}
                />
              )}
            />
            <Route
              exact
              path={`/${this.props.match.params.pair}/from`}
              render={props => (
                <SelectCoin
                  {...props}
                  changePair="from"
                  title="You send"
                  pair={this.props.match.params.pair}
                  coinStore={this.props.coinStore}
                  infoStore={this.props.infoStore}
                />
              )}
            />
            <Route
              exact
              path={`/${this.props.match.params.pair}/to`}
              render={props => (
                <SelectCoin
                  {...props}
                  changePair="to"
                  title="You receive"
                  pair={this.props.match.params.pair}
                  coinStore={this.props.coinStore}
                  infoStore={this.props.infoStore}
                />
              )}
            />
            <Route
              strict
              exact
              path={`/${this.props.match.params.pair}`}
              render={props => (
                <Amount
                  {...props}
                  coinStore={this.props.coinStore}
                  recentExchangeStore={this.state.recentExchangeStore}
                  infoStore={this.props.infoStore}
                />
              )}
            />
            <Route component={NotFound} />
          </Switch>
        : <Loading />}
      </div>
    );
  }
}

Pair.propTypes = {
  exchangeStore: PropTypes.object.isRequired,
  infoStore: PropTypes.object.isRequired,
  coinStore: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default Pair;



// WEBPACK FOOTER //
// ./src/scenes/Pair/index.jsx